import { MediaQuery } from 'utils/media_query';
import './index.scss';

(function ($) {
  const $featuredBannersSlider = $('#js-featured-books');

  if (MediaQuery.is('lt_lg')) {
    vendorManager.ensure('swiper', () => {
      $featuredBannersSlider.find('.swiper-container').swiper({
        loop: true,
        grabCursor: true,
        slidesPerView: 3,
        paginationClickable: true,
        nextButton: $featuredBannersSlider.find('.swiper-button-next').get(0),
        prevButton: $featuredBannersSlider.find('.swiper-button-prev').get(0),
        breakpoints: {
          992: {
            slidesPerView: 2
          },
          720: {
            slidesPerView: 0
          }
        }
      });

      $featuredBannersSlider.lazyReady();
    });
  } else {
    $featuredBannersSlider.lazyReady();
  }
})(jQuery);
